import React, { CSSProperties, ReactNode, useState } from 'react';
import DialogBase from '../../../base/DialogBase/DialogBase';
import { useGetAllProjectsWithoutPermissionQuery, useSetProjectAccessMutation } from '../../../generated/graphql';
import { FormAutoComplete } from '../../form';
import styles from './RequestAccessProjectDialog.module.css';

type RequestAccessProjectDialogProps = {
    onClose: () => void,
    visible: boolean,
    style?: CSSProperties | undefined,
    children?: ReactNode | undefined,
};

const RequestAccessProjectDialog = (props: RequestAccessProjectDialogProps) => {
    const { style, visible, onClose } = props;
    const [setProjectAccess, setProjectAccessResult] = useSetProjectAccessMutation();
    const [searchText, setSearchText] = useState('');
    const [validationError, setValidationError] = useState('');

    const projects = useGetAllProjectsWithoutPermissionQuery({
        variables: { contains: searchText }
    });

    const handleSubmit = () => {
        const selected = projects.data?.AllProjects?.nodes?.filter(l => l?.name === searchText)[0];
        if (!searchText) {
            setValidationError('Please fill all of the following fields.');
            return;
        }
        if (!selected) {
            setValidationError('Please Select A Valid Project!');
            return;
        }
        setValidationError('');
        setProjectAccess({
            variables: { projectId: selected?.id }
        })
            .then(() => { onClose(); })
            .catch(() => {});
    };

    return (
        <DialogBase
            title="Request Access"
            type="OkCancel"
            isLoading={setProjectAccessResult.loading}
            visible={visible}
            onClose={onClose}
            onSubmit={handleSubmit}
            validationError={validationError}
            className={styles.RequestAccessProjectDialog}
            style={style}
            data-testid="RequestAccessProjectDialog">
            <FormAutoComplete
                label="Project"
                name="project"
                value={searchText}
                onChange={setSearchText}
                options={(projects.data?.AllProjects?.nodes?.map(p => p?.name) || []).filter((n): n is string => !!n)}
            />
        </DialogBase>
    );
};

export default RequestAccessProjectDialog;